














































































































































// Models
import Vue from "vue";
import Pager from "../../../models/Pager";
import store, { CashStatementStore } from "../services/store";
import CashDocumentDisplay from "../models/CashDocumentDisplay";
import CashDocument from "../models/CashDocument";
import { GridColumnProps } from "@progress/kendo-vue-grid";

// Components
import Paginator from "@/components/Paginator.vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import IconButton from "@/components/IconButton.vue";
import SpecialDimensionButton from "@/components/SpecialDimensionButton.vue";
import CashDocByReceipts from "../receipt/views/CashDocByReceipts.vue";
import eventBus from "@/services/eventBus";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import {
  ApiSearchColumn,
  ColumnType,
} from "@/components/apiSearch/models/ApiSearch";
import { t } from "@/plugins/i18n";

interface Data {
  store: CashStatementStore;
  pager: Pager;
  importingIncomingInvoice: boolean;
  importingOutgoingInvoice: boolean;
  isStatementCashierTheCurrentUser: boolean;
  creatingCashDocByReceipts: boolean;
  loader: boolean;
}

interface Methods {
  pagerChanged(pager: Pager): void;
  newDocument(): void;
  importIncomingInvoice(): void;
  importOutgoingInvoice(): void;
  editItem(item: CashDocumentDisplay): void;
  newDocumentFromInvoice(): void;
}

interface Computed {
  columns: GridColumnProps[];
  items: CashDocumentDisplay[];
  columnsApiSearch: ApiSearchColumn[];
  url: string;
}

const DEFAULT_MIN_DATE = "2000-01-01";

export default Vue.extend<Data, Methods, Computed, {}>({
  components: { MoneyDisplay, IconButton, SpecialDimensionButton, CashDocByReceipts, ApiSearchPage },

  props: { disabled: Boolean },

  data: () => ({
    store,
    pager: new Pager(),
    importingIncomingInvoice: false,
    importingOutgoingInvoice: false,
    isStatementCashierTheCurrentUser: false,
    creatingCashDocByReceipts: false,
    loader: false,
    minCloseDate: DEFAULT_MIN_DATE,
    maxCloseDate: "",
  }),

  created() {
    this.pager = new Pager({ list: this.items });
  },

  async beforeMount() {
    this.isStatementCashierTheCurrentUser =
      this.store.currentUser.id == this.store.cashStatement.cashier;

      eventBus.$on("cash-documents:load",(value)=>{
        this.loader = value;
      })

      eventBus.$on("cachdoccreatedfromviri", () =>{
        this.store.loadCashDocumentsByStatementId(store.cashStatement.id)
        this.pager.list = this.items;
      })
      
      await this.store.loadCashDocumentStatuses();
  },

  methods: {
    pagerChanged(pager) {
      this.pager = pager;
    },

    newDocument() {
      if (store.cashStatement.currency != 'HUF' && this.items.some(x => x.status == "Feldolgozás alatt")) {
        eventBus.$emit("error", t("CashStatement_DevizaPenztarEsetenEgyszerreCsakEgy"));
        return;
      }     

      this.store.cashDocument = new CashDocument();
      const cashStatementId = Number(this.$route.params.cashStatementId) || 0;
      this.$router.push(`/cash-statement/edit/${cashStatementId}/0`);
    },

    newDocumentFromInvoice(){
      if (store.cashStatement.currency != 'HUF' && this.items.some(x => x.status == "Feldolgozás alatt") && !this.creatingCashDocByReceipts) {
        eventBus.$emit("error", t("CashStatement_DevizaPenztarEsetenEgyszerreCsakEgy"));
        return;
      }

      this.creatingCashDocByReceipts = !this.creatingCashDocByReceipts;
    },

    importIncomingInvoice() {
      this.$emit("importGENI");
    },

    importOutgoingInvoice() {
      this.$emit("importGENO");
    },

    editItem(item) {
      const cashStatementId = Number(this.$route.params.cashStatementId) || 0;
      this.$router.push(`/cash-statement/edit/${cashStatementId}/${item.id}`);
    },
  },

  computed: {
    columns: () => [
    { width: 120, cell: "commandTemplate" },
      { field: "uniqueNo", title: t("Sorszam"), cell: "uniqueNoTemplate" },
      { field: "partnerName", title: t("CashStatement_Befizeto") },
      {
        field: "currAmount",
        title: t("Osszeg"),
        cell: "amountTemplate",
        className: "right_text",
        headerClassName: "right_text",
      },
      { field: "status", title: t("Allapot") },
      {
        field: "closeDate",
        title: t("CashStatement_BizonylatDatuma"),
        type: "date",
        format: "{0: yyyy. MM. dd.}",
        className: "center_text",
        headerClassName: "center_text",
      },
      {
        field: "insDate",
        title: t("RogzitesDatuma"),
        type: "date",
        format: "{0: yyyy. MM. dd.}",
        className: "center_text",
        headerClassName: "center_text",
      },
      { field: "comment", title: t("Megjegyzes") },
    ],

    columnsApiSearch: () => [
    { width: 100, cell: "commandTemplate", filterable: false, field: "id", income: "income" },
      { field: "uniqueNo", title: t("Sorszam"), income: "income" },
      { field: "partnerName", title: t("CashStatement_Befizeto") },
      { field: "currAmount", title: t("Osszeg"), type: ColumnType.Money, cell: "amountTemplate" },
      { field: "status", title: t("Allapot"), 
      multiselectOptions: store.cashDocumentStatuses.map((x) => ({ text: x.name, value: x.id })),
        multiselect: true,
      multiselectField: "selectedStatuses" },
      { field: "closeDate", title: t("CashStatement_BizonylatDatuma"), type: ColumnType.Date, range: true, filterable: true },
      { field: "insDate", title: t("RogzitesDatuma"), type: ColumnType.Date, range: true, filterable: true },
      { field: "balance", title: t("Egyenleg"), type: ColumnType.Money },
      { field: "comment", title: t("Megjegyzes"), filterable: false },
    ],

    items() {
      return this.store.cashDocuments;
    },

    url() {
      const cashStatementId = Number(this.$route.params.cashStatementId) || 0;
      return `cash-document/statement/search/${cashStatementId}`;
    },
  },

  watch: {
    items(){
      (this.$refs.apiSearch as any).refreshClick();
    }
  },
});
